// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Image } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconImage(props: any) {
    return <IconBase icon={Image} {...props} />
  }

  export default IconImage
  